<!-- Do NOT change this to ngIf  -->
<p [ngStyle]="{ display: showNoActionsMessage ? 'block' : 'none' }" style="padding: 10px 10px 0 10px">
  There are no actions available at the current location.
</p>

<section [ngStyle]="{ display: showNoActionsMessage ? 'none' : 'block' }" id="field-selection-tab-wrapper">
  <mat-tab-group
    class="field-selection"
    [disablePagination]="true"
    [(selectedIndex)]="selectedTabIndex"
    animationDuration="200ms"
    (selectedIndexChange)="reInkChildren()"
    >
    <!-- debugger -->
    @if (environment.isDev && debugService.showDebugPanel$ | async) {
      <mat-tab title="Debugger">
        <ng-template mat-tab-label>
          <mat-icon title="Debugger">bug_report</mat-icon>
          <span>Debugger</span>
        </ng-template>
        <app-debugger></app-debugger>
      </mat-tab>
    }

    <!-- DATA FIELDS -->
    <mat-tab [disabled]="!tabValidStates[0]">
      <ng-template mat-tab-label>
        <mat-icon title="Data fields">storage</mat-icon>
        <span>Data Fields</span>
      </ng-template>
      <app-data-fields
        #dataFieldsComponent
        (fieldInsertedEvent)="fieldInsertedEvent.emit($event)"
        (fieldUpdatedEvent)="fieldUpdatedEvent.emit($event)"
        >
      </app-data-fields>
    </mat-tab>

    <!-- SENDER FIELDS -->
    <mat-tab [disabled]="!tabValidStates[1]">
      <ng-template mat-tab-label>
        <mat-icon title="Fields for the {{ namespace | SentenceCase }} user sending the document">account_circle</mat-icon>
        <span>Document sender</span>
      </ng-template>
      <app-document-sender
        #documentSenderComponent
        (fieldClickedEvent)="fieldInsertedEvent.emit($event)"
        (fieldUpdatedEvent)="fieldUpdatedEvent.emit($event)"
        >
      </app-document-sender>
    </mat-tab>

    <!-- SIGNATURE FIELDS -->
    @if (signatureProviderName) {
      <mat-tab [disabled]="!tabValidStates[2]" title="Signature fields">
        <ng-template mat-tab-label>
          <mat-icon title="Signature fields">draw</mat-icon>
          <span>Signature Fields</span>
        </ng-template>
        <app-docusign #docusignComponent (fieldClickedEvent)="onSignatureInserted($event)"> </app-docusign>
      </mat-tab>
    }

    <!-- SCRIPT FIELDS -->
    <mat-tab [disabled]="!tabValidStates[3]" title="Script fields">
      <ng-template mat-tab-label>
        <mat-icon title="Script fields">code</mat-icon>
        <span>Scripts</span>
      </ng-template>
      <app-script-fields #scriptFieldsComponent></app-script-fields>
    </mat-tab>

    <!-- IMAGE FIELDS -->
    @if (imageFieldsSupported) {
      <mat-tab [disabled]="!tabValidStates[4]" title="Image fields">
        <ng-template mat-tab-label>
          <mat-icon title="Image fields">image</mat-icon>
          <span>Image Fields</span>
        </ng-template>
        <app-image-fields #imageFieldsComponent></app-image-fields>
      </mat-tab>
    }

    <!-- Conditional Fields FIELDS -->
    <mat-tab [disabled]="!tabValidStates[5]" title="Conditional fields">
      <ng-template mat-tab-label>
        <mat-icon title="Conditional fields">check_box</mat-icon>
        <span>Conditional Fields</span>
      </ng-template>
      <app-conditional-fields #conditionalFieldsComponent></app-conditional-fields>
    </mat-tab>

    <!-- AI Assist Tab -->
    @if (aiAssistTabVisible) {
      <mat-tab [disabled]="!tabValidStates[6]" title="Kyloe AI Assist prompts">
        <ng-template mat-tab-label>
          <mat-icon title="Kyloe AI Assist prompts">auto_awesome</mat-icon>
          <span>AI Assist Prompt</span>
        </ng-template>
        <app-ai-assist-prompt #aiAssistPromptComponent></app-ai-assist-prompt>
      </mat-tab>
    }

    <!-- ADC Migration Tab -->
    @if (adcMigrationTabVisible) {
      <mat-tab title="ADC Migration">
        <ng-template mat-tab-label>
          <mat-icon title="ADC Migration">transform</mat-icon>
          <span>ADC Migration</span>
        </ng-template>
        <app-adc-migration #adcMigrationComponent>
        </app-adc-migration>
      </mat-tab>
    }
  </mat-tab-group>
</section>
